import { AppointmentGoogleConnection } from './components/AppointmentGoogleConnection';

export const AppointmentConfigPage = (): JSX.Element => <AppointmentGoogleConnection />;
